// Cloud moves use mouse gestures; native drag-out starts only at the frame edge.
export default {
 data:()=>({columnDrag:null,columnDrop:null,columnMoveBusy:false,externalDropTarget:null}),
 watch:{ownerId(){this.cancelColumnDrag()},'space.ownerId'(){this.cancelColumnDrag()},viewMode(){this.cancelColumnDrag()},mode(){this.cancelColumnDrag()}},
 created(){
  this.columnDragKey=event=>{if(event.key==='Escape')this.cancelColumnDrag()}
  this.columnDragBlur=()=>this.cancelColumnDrag()
  this.columnDragExit=event=>{if(!event.relatedTarget&&this.driveDrag&&this.driveDrag.column&&this.driveDrag.started)this.exportColumnDrag()}
  this.columnVisibility=event=>{if(event.source===window.parent&&event.origin===location.origin&&event.data&&event.data.type==='hxt-drive-visibility'&&!event.data.visible)this.cancelColumnDrag()}
  window.addEventListener('keydown',this.columnDragKey);window.addEventListener('blur',this.columnDragBlur);window.addEventListener('mouseout',this.columnDragExit);window.addEventListener('message',this.columnVisibility)
 },
 beforeDestroy(){this.cancelColumnDrag();window.removeEventListener('keydown',this.columnDragKey);window.removeEventListener('blur',this.columnDragBlur);window.removeEventListener('mouseout',this.columnDragExit);window.removeEventListener('message',this.columnVisibility)},
 methods:{
  columnOwner(){return String(this.ownerId==null?this.space.ownerId||'':this.ownerId)},
  startColumnDrag(event,column,row){
   if(event.button!==0||row.pending||this.mode==='trash'||this.columnMoveBusy||!this.columnOwner())return
   this.contextMenu=null;this.driveDrag={row:{...row,parentId:row.parentId==null?column.parentId:row.parentId},x:event.clientX,y:event.clientY,started:false,column:true,owner:this.columnOwner()}
  },
  columnTarget(event){
   const element=event.target&&event.target.closest&&event.target.closest('.drive-column')
   if(!element||!this.$el.contains(element))return null
   const index=Number(element.getAttribute('data-drive-column')),column=this.columns[index]
   if(!column)return null
   const button=event.target.closest('.drive-column-row'),id=button&&button.getAttribute('data-drive-node')
   const row=id&&this.columnRows(column).find(row=>String(row.id)===id)
   if(row&&row.pending)return null
   if(row&&row.kind==='DIR')return {id:row.id,name:row.name,index,rowId:row.id,parents:this.columns.slice(0,index+1).map(c=>c.parentId).concat(row.id)}
   return column.tree?{id:column.parentId,name:column.name,index,rowId:null,parents:this.columns.slice(0,index+1).map(c=>c.parentId)}:null
  },
  columnDropReason(row,target){
   if(!target)return '请拖到已打开的目录或文件夹上'
   if(row.kind==='DIR'&&target.parents.some(id=>String(id)===String(row.id)))return '不能移动到自身或子目录'
   if(String(row.parentId||0)===String(target.id))return '已经在此目录，无需移动'
   return ''
  },
  moveColumnDrag(event){
   const drag=this.driveDrag;if(!drag||!drag.column)return
   if(event.buttons===0||drag.owner!==this.columnOwner()){this.cancelColumnDrag();return}
   if(!drag.started&&Math.hypot(event.clientX-drag.x,event.clientY-drag.y)<8)return
   drag.started=true;event.preventDefault();this.suppressOpenUntil=Date.now()+600
   if(event.clientX<=1||event.clientY<=1||event.clientX>=window.innerWidth-1||event.clientY>=window.innerHeight-1){this.exportColumnDrag();return}
   const target=this.columnTarget(event),reason=this.columnDropReason(drag.row,target)
   this.columnDrop=target;this.columnDrag={row:drag.row,x:Math.max(8,Math.min(event.clientX+14,window.innerWidth-290)),y:Math.max(8,Math.min(event.clientY+14,window.innerHeight-85)),reason,targetName:target&&target.name}
  },
  cancelColumnDrag(){
   if(this.driveDrag&&this.driveDrag.column){if(this.driveDrag.started)this.suppressOpenUntil=Date.now()+300;this.driveDrag=null}
   this.columnDrag=null;this.columnDrop=null;this.externalDropTarget=null
  },
  exportColumnDrag(){
   const drag=this.driveDrag;if(!drag||!drag.column)return
   if(!this.mapping.available||this.adminView){this.cancelColumnDrag();return}
   drag.column=false;drag.started=true;this.columnDrag=null;this.columnDrop=null
   this.nativeCall('drag',{id:drag.row.id}).then(result=>{if(result==='ready')this.$message.info('文件已准备好，请再次拖拽到电脑目录')}).catch(this.report).finally(()=>{this.suppressOpenUntil=Date.now()+300;if(this.driveDrag===drag)this.driveDrag=null})
  },
  async finishColumnDrag(event){
   const drag=this.driveDrag;if(!drag||!drag.column)return
   const target=this.columnTarget(event),reason=this.columnDropReason(drag.row,target),started=drag.started
   this.cancelColumnDrag();if(!started||drag.owner!==this.columnOwner()||this.columnMoveBusy)return
   if(reason){this.$message.warning(reason);return}
   this.columnMoveBusy=true
   try{
    await this.request('/nodes/move',{id:drag.row.id,parentId:target.id,expectedRevision:drag.row.revision},'POST')
    if(this.disposed||drag.owner!==this.columnOwner())return
    this.$message.success('已移动到“'+target.name+'”');await this.refresh()
    if(this.canMap)this.nativeCall('wake').catch(()=>{})
   }catch(error){
    if(this.disposed||drag.owner!==this.columnOwner())return
    if(/同名/.test(error.message||''))this.$alert('目标目录已有同名文件或文件夹，未移动，也不会覆盖现有内容。','名称重复',{type:'warning',confirmButtonText:'知道了'}).catch(()=>{})
    else if(error.uncertain){this.$message.warning('移动结果暂未确认，正在刷新目录，请确认后再操作');await this.refresh()}
    else this.report(error)
   }finally{this.columnMoveBusy=false}
  },
  columnDropClass(column,index,row=null){
   const target=this.columnDrag?this.columnDrop:this.externalDropTarget
   if(!target||target.index!==index||(row?String(target.rowId)!==String(row.id):target.rowId!=null))return {}
   return {'is-drop-target':!this.columnDrag||!this.columnDrag.reason,'is-drop-denied':!!(this.columnDrag&&this.columnDrag.reason)}
  },
  externalColumnOver(event){
   if(this.mode!=='files')return
   this.dragging=false;this.externalDropTarget=this.columnTarget(event)
   if(event.dataTransfer)event.dataTransfer.dropEffect=this.externalDropTarget?'copy':'none'
  },
  externalColumnLeave(event){if(!event.currentTarget.contains(event.relatedTarget))this.externalDropTarget=null},
  externalDriveTarget(event){
   if(this.mode!=='files')return null
   if(event.target.closest('.drive-column'))return this.columnTarget(event)
   const element=event.target.closest('[data-drive-upload-node]'),tableRow=event.target.closest('.el-table__row')
   let row=element&&this.shownRows.find(item=>String(item.id)===element.getAttribute('data-drive-upload-node'))
   if(!row&&tableRow)row=this.shownRows[Array.from(tableRow.parentElement.children).indexOf(tableRow)]
   if(row&&row.pending)return null
   if(row&&row.kind==='DIR')return {id:row.id,name:row.name,rowId:row.id,index:null}
   return {id:this.parentId,name:this.trail.length?this.trail[this.trail.length-1].name:'全部文件',rowId:null,index:null}
  },
  externalDriveOver(event){
   this.externalDropTarget=this.externalDriveTarget(event);this.dragging=!!this.externalDropTarget&&this.externalDropTarget.rowId==null
   if(event.dataTransfer)event.dataTransfer.dropEffect=this.externalDropTarget?'copy':'none'
  },
  uploadRowClass({row}){return this.externalDropTarget&&String(this.externalDropTarget.rowId)===String(row.id)?'drive-upload-target':''},
  async dropByLocation(event){
   const target=this.externalDriveTarget(event);this.dragging=false;this.externalDropTarget=null
   if(!target)return this.$message.warning('请拖到已打开的目录或文件夹上')
   await this.drop(event,target.id)
  },
  dropIntoColumn(event){return this.dropByLocation(event)}
 }
}
